import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import useQueryParam from '~/client/hooks/router/useQueryParam';
import type { TournamentFragment } from '../../graphql/TournamentFragment.generated';
import useTournaments from '../../hooks/useTournaments/useTournaments';

const useGameBanner = () => {
  const [handle] = useQueryParam('tournament');
  const { game } = useGameContext();
  const { tournaments, loading } = useTournaments({
    status: 'current',
    gameId: game?.id,
  });

  const { node: preferredTournament } =
    tournaments?.find(({ node }) => node?.shortUrl === handle) || {};

  const tournament =
    preferredTournament ?? (tournaments?.[0]?.node as TournamentFragment);

  return { tournament, handle, loading };
};

export default useGameBanner;
